import { jsx } from 'react/jsx-runtime';
import { ErrorBoundary } from 'react-error-boundary';
import { Alert } from '@zooplus/ui-components';
import { useTranslation } from '../../hooks/useTranslations.js';
import { useConfig } from '../../providers/ConfigProvider.js';
import { getSentryService } from '../../services/sentryService.js';

/**
 * ErrorBoundary which will send to Sentry all the uncaptured exceptions raised from the given children.
 */
const SentryErrorBoundary = ({ children, fallbackRender, featureName, }) => {
    const { t } = useTranslation();
    const { config } = useConfig();
    const sentry = getSentryService(config.env, config);
    const handleError = (error) => {
        // 1- Simple approach : capture error with no tag
        // ------------------------
        sentry.captureException(error, (scope) => scope.setTags({ featureName }));
        // ------------------------
        // 2- Approach adding a tag
        // ------------------------
        // captureException(error, {
        //   // If you need to send things specific to this error on top of the error
        //   // itself then use this captureContext
        //   captureContext: (scope) => scope.setTags({ type: 'errorBoundary' }),
        // });
        // ------------------------
        sentry.captureException(error, (scope) => scope.setTags({ featureName }));
    };
    const fallbackRenderNullSafe = fallbackRender ??
        (() => {
            return (jsx(Alert, { variant: "warning", children: t('checkout.payment.creditcard.error.method.unavailable') }));
        });
    return (jsx(ErrorBoundary, { fallbackRender: fallbackRenderNullSafe, onError: handleError, children: children }));
};

export { SentryErrorBoundary as default };
//# sourceMappingURL=SentryErrorBoundary.js.map
